import { useParams } from 'next/navigation'

export default function useGetSlug() {
  const params = useParams<{ taskId: string; taskToolId: string }>()
  return { taskId: params?.taskId || '', toolId: params?.taskToolId || '' }
}
